module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/61.13d47890.png";